import React, { useState, useCallback, useRef, useEffect } from 'react';
import KeyboardV2 from '@components/KeyboardV2';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/indexRevamp';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import cn from 'classnames';
import styles from './contactFormRevamp.module.scss';
import { getObjectValue } from '../../utility/utills';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable'
import { ReactComponent as Cross } from '@assets/images/cross.svg';

const ContactForm = ({ setOnQuestion, onQuestion, submitContactForm, confirmationMessage, isKiosk, isServer, setProgressWidth, progressWidth, surveyQuestion, serverAppTheme, setErrorPopUp}) => {
  const contactDetails = getObjectValue(() => JSON.parse(sessionStorage.getItem('contactDetails')), {})
  const [isSwipedDown, setSwipedDown] = useState();
  const [keyboardType, setKeyboardType] = useState('');
  const [formValues, setFormValues] = useState({
    contactEmailAddress: contactDetails?.contactEmailAddress ? contactDetails.contactEmailAddress : '',
    contactCountryCode: contactDetails?.contactCountryCode ? contactDetails.contactCountryCode : '1',
    contactPhoneNumber: contactDetails?.contactPhoneNumber ? contactDetails.contactPhoneNumber : '',
  });

  const formValuesRef = useRef(formValues);
  const keyboardTypeRef = useRef(keyboardType);

  useEffect(() => { formValuesRef.current = formValues; }, [formValues]);
  useEffect(() => { keyboardTypeRef.current = keyboardType; }, [keyboardType]);

  const handleBlur = (currentField) => {
    setSwipedDown(true);
    const element = document.getElementById(currentField);
    element.blur();
  };

  const handleInputChange = useCallback((name, value) => {
    setFormValues(prev => {
      let formInpValue = { ...prev, [name]: value };
      if (name === 'contactCountryCode') {
        formInpValue = { ...formInpValue, contactPhoneNumber: '' };
      }
      return formInpValue;
    });
  }, []);


  const handleErrors = (inputField, inpValue) => {
    switch (inputField) {
      case 'contactEmailAddress':
        if (!inpValue) return '';
        const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        const isValidEmail = inpValue.match(pattern);
        if (!isValidEmail) {
          setErrorPopUp({
            res: CUSTOM_MESSAGES().SURVEY_ENTER__VALID_EMAIL,
            noErrorTxt: true
          });
          return 'invalid';
        }
        return '';

      case 'contactPhoneNumber':
        if (!inpValue) return '';
        if (Number(formValues.contactCountryCode) === 1 && inpValue.length !== 10) {
          setErrorPopUp({
            res: CUSTOM_MESSAGES().SURVEY_VALID_PHONE_NUMBER,
            noErrorTxt: true
          });
          return 'invalid';
        }
        return '';
    }
  };


  const validate = () => {
    const contactEmailAddress = handleErrors('contactEmailAddress', formValues.contactEmailAddress)
    const contactPhoneNumber = handleErrors('contactPhoneNumber', formValues.contactPhoneNumber)

    const errorMessages = [];
    if (contactEmailAddress) errorMessages.push('Email');
    if (contactPhoneNumber) errorMessages.push('Phone Number');

    if (errorMessages.length > 0) {
      setErrorPopUp({
        res: `Enter valid ${errorMessages.join(' and ')}`,
        noErrorTxt: true
      });
      return;
    }
    const contactDetails = {
      contactEmailAddress: formValues.contactEmailAddress || null,
      contactPhoneNumber: formValues.contactPhoneNumber || null,
      contactCountryCode: formValues.contactCountryCode || null,
    };
    sessionStorage.setItem('contactDetails', JSON.stringify(contactDetails));
    submitContactForm({});
  };


  const handleClear = (fieldName) => {
    setFormValues(prev => ({
      ...prev,
      [fieldName]: ''
    })
    )
  }

  const handleKeyboardInput = useCallback((value) => {
    const currentKbType = keyboardTypeRef.current;
    const currentValue = formValuesRef.current[currentKbType] || '';
    if (currentKbType === 'contactPhoneNumber' && value !== '{bksp}') {
      const maxLen = Number(formValuesRef.current.contactCountryCode) === 1 ? 10 : 15;
      if (currentValue.length >= maxLen) return;
    }
    const newValue = value === '{bksp}' ? currentValue.slice(0, -1) : currentValue.concat(value);
    handleInputChange(currentKbType, newValue);
  }, [handleInputChange]);

  const handleCloseKeyboard = useCallback(() => setSwipedDown(false), []);

  const handleClearPhone = useCallback(() => handleInputChange('contactPhoneNumber', ''), [handleInputChange]);

  const keyboardComponentType = keyboardType === 'contactPhoneNumber' ? 'numericWithBin' : 'textWithoutNumeric';

  return (
    <div className={'row mx-0 h-100'} style={{color: serverAppTheme?.primary_text}}>
        <div className={cn('col-12')}>
         <p className={cn(' text-center fs_20 fw-600')}>{CUSTOM_MESSAGES().MAY_WE_CONTACT_YOU_ABOUT_YOUR_EXPERIENCE}</p>
       </div>
        <div className='h-83 col-12 px-0'>
         <div className={styles.col}>
          <p className={cn(styles.question, 'p-2 position-relative fw-normal')} style={{fontSize:'18px'}}>{CUSTOM_MESSAGES().WHAT_IS_THE_BEST_EMAIL_ADDRESS_TO_REACH_YOU}</p>
          <input
            id='contactEmailAddress'
            type="text"
            name="contactEmailAddress"
            className={cn(styles.inputField, 'w-100 text-left pl-3')}
            style={{background: serverAppTheme?.inputBg, borderBottom:serverAppTheme?.inputBorder_Bottom, color:serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder}}
            placeholder={CUSTOM_MESSAGES().ENTER_EMAIL_ADDRESS}
            value={formValues.contactEmailAddress}
            onFocus={() => { handleBlur('contactEmailAddress'); setKeyboardType('contactEmailAddress'); }}
          />
          {formValues.contactEmailAddress &&
            <TouchableDiv
              role="presentation"
              className="position-absolute h-100"
              style={{ top: '13%', right: '1%' }}
              onClick={() => handleClear('contactEmailAddress')}
            >
              <Cross fill={serverAppTheme?.iconcolor} />
            </TouchableDiv>
          }
      </div>
      <div className={styles.col}>
        <div className='col-12 px-0 d-flex'>
           <div className='w-90 px-0'>
              <p className={cn('fw-normal mb-0 p-2 text-left position-relative')} style={{fontSize:'18px'}}>{CUSTOM_MESSAGES().YES_ALSO_CONTACT_ME_BY_PHONE}</p>
           </div>
        </div>
        <div className={cn('p-0 position-relative fs_18')}>
          <PhoneNumberComponent
              countryCode={formValues.contactCountryCode}
              styles={{
                bottom:"0%",
                fontSize:'24px',
              }}
              isCustomWidth='w-16 text-center'
              handleCountryCodeChange={(value) => handleInputChange('contactCountryCode', value.id)}
              serverAppTheme={serverAppTheme}
              screenType='survey'
            />
            <input
              id="contactPhoneNumber"
              type="textWithOutDone"
              name='contactPhoneNumber'
              className={cn('text-left w-100', styles.inputField)}
              style={{paddingLeft:'33%',background: serverAppTheme?.inputBg, borderBottom:serverAppTheme?.inputBorder_Bottom, color:serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder}}
              placeholder={CUSTOM_MESSAGES().ENTER_PHONE_NUMBER}
              value={Number(formValues.contactCountryCode) === 1 ? getFormatedPhoneNumber(formValues.contactPhoneNumber) : formValues.contactPhoneNumber}
              onFocus={(e) => { handleBlur('contactPhoneNumber'); handleInputChange(e); setKeyboardType('contactPhoneNumber') }}
            />
            {formValues.contactPhoneNumber &&
              <TouchableDiv
                role="presentation"
                className="position-absolute h-100"
                style={{ top: '13%', right: '1%' }}
                onClick={() => handleClear('contactPhoneNumber')}
              >
                <Cross fill={serverAppTheme?.iconcolor} />
              </TouchableDiv>
            }
            </div>
          </div>
          <div className={cn('row mx-0 p-0 align-items-end justify-content-center h-15')} style={isKiosk ? { position: 'fixed', bottom: '10%', width: '100%', left: '5%'}:{ position: 'fixed', bottom: '2%', width: '94%', left:'1rem'}}>
            <div className={cn('col text-center px-1')}>
            <TouchableButton className={cn(styles.btnHeight, ' rounded my-1 w-100 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color', isKiosk ? 'btn35' : 'btn44')} style={{height: isServer && "4.2rem", background:serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.cancleBtn_font, border: serverAppTheme?.cancleBtn_Border}} onClick={() => { setOnQuestion(onQuestion === 0 ? 'none' : onQuestion - 1);  }} role="presentation" rippleEffect={true}>
              <div className={cn(isKiosk ? 'fs-30' : 'fs_16 ')} style={{fontSize: isServer? "28px": "20px"}}>{LABEL().PREVIOUS}</div>
            </TouchableButton>
          </div>
            <div className="col text-center px-1">
              <TouchableButton type="button" className={cn(styles.btnHeight, 'btn rounded my-1 text-center  w-100', 'od-primary-btn-bg-color od-primary-btn-font-color', isKiosk ? 'btn35' : 'btn')} style={{height: isServer && "4.2rem", backgroundColor: serverAppTheme?.secondaryBtn, color: 'white'}} onClick={(e) => { e.preventDefault(); validate(); }} rippleEffect={true}>
                <div className={cn(isKiosk ? 'fs-30' : 'fs_16')} style={{fontSize: isServer? "28px": "20px", fontWeight:'600'}}>{confirmationMessage === '' ? LABEL().DONE : LABEL().NEXT}</div>
              </TouchableButton>
            </div>
          </div>
        </div>
        {isSwipedDown && (
          <div className={cn('w-100 align-items-end p-0 position-fixed', styles.myThemeForAlphaNumber)}>
              <KeyboardV2
                setKeyboardType={setKeyboardType}
                type={keyboardComponentType}
                onClickBtn={handleKeyboardInput}
                closeKeyboard={handleCloseKeyboard}
                btnSize={keyboardType === "btn80 py-2"}
                customClass='fs-30 p-2'
                isDone={true}
                setinputEmpty={handleClearPhone}
              />
          </div>
        )}
    </div>
  );
};

export default ContactForm;
